import React, {useContext,useEffect,useState} from 'react'
import { FormHelperText, Box ,TextField,Grid,FormControlLabel,FormControl,RadioGroup,Radio,FormLabel} from "@material-ui/core";
import {useAlumno} from '../../../Context/alumnoContext'
import REG_EX from '../../../Helpers/regex'

export const Cuestionario = ({objetoModificacion,paso_cumplido,validacion,validar})=>{
    const [avisar,setAvisar] =useState({});
    const [fecha_conversion,set_fecha_conversion]=useState(objetoModificacion?.obj?.fecha_conversion || null)
    const [fecha_bautismo_a,set_fecha_bautismo_a]=useState(objetoModificacion?.obj?.fecha_bautismo_a || null)

    const handleChange = (e,regex,noupper)=>{
        // no se transforma más en mayúsculas a partir de enero 2026
        if(e.target.value === '' || ((regex && regex?.test(e.target.value)|| !regex))){
            const obj_aux = {...objetoModificacion.obj}
            obj_aux[e.target.name]=e.target.value;
            objetoModificacion.set({...obj_aux})
        }
    }
    
    const changeOnblur = (e)=>{
        if(!e.target.value){
            const aux = {...avisar};
            aux[e.target.name] = true
            setAvisar(aux)
        }else{
            const aux = {...avisar};
            aux[e.target.name] = false
            setAvisar(aux)
        }
    }

React.useEffect(()=>{
       
        objetoModificacion.set({...objetoModificacion.obj,
                                fecha_conversion:fecha_conversion})
},[fecha_conversion])

React.useEffect(()=>{
       
    objetoModificacion.set({...objetoModificacion.obj,
        fecha_bautismo_a:fecha_bautismo_a})
},[fecha_bautismo_a])

const checkvalidacion = (campo,validacion)=>{

    if (!validar) return ''

    const objetoValidacion = validacion(validar)
    const resultado = objetoValidacion[0];
    const texto = objetoValidacion[1]
    const campos = objetoValidacion[2]

    if(resultado==true || !(campos instanceof Array) || campos.length==0){
        return ''
    }
    if(campos.some(item=>item.campo==campo)){
        return campos.filter(item=>item.campo==campo)[0]?.texto || ''
    }else{
        return ''
    }
}

return <Box sx={{marginTop:'20px'}}>
        <h3 className='text-xl font-medium text-gray-800 mb-1'>Información sobre conversión y bautismos</h3>
        <Grid item xs={12}>
                <div className='form-card'><div>Año de conversión: <span className='c-obl'></span></div>
                    <TextField 
                                onBlur={changeOnblur} 
                                fullWidth={true} 
                                type='text' 
                                id='ub-year-conv'
                                name='year_conversion'
                                inputProps={{
                                    maxLength:4
                                }}
                                value={objetoModificacion.obj?.year_conversion || ''} 
                                placeholder='Tu respuesta' 
                                onChange={(e)=>{
                                    handleChange(e,REG_EX.NUMERIC)
                                }}
                        />
                    <FormHelperText className="Mui-error">{checkvalidacion('year_conversion',validacion)}</FormHelperText>
                </div>
        </Grid>
        <Grid item xs={12}>
                <div className='form-card'><div>Año del bautismo en agua: <span className='c-obl'></span></div>
                    <TextField 
                                onBlur={changeOnblur} 
                                fullWidth={true} 
                                type='text' 
                                id='ub-year-baut'
                                name='year_bautismo'
                                inputProps={{
                                    maxLength:4
                                }}
                                value={objetoModificacion.obj?.year_bautismo || ''} 
                                placeholder='Tu respuesta' 
                                onChange={(e)=>{
                                    handleChange(e,REG_EX.NUMERIC)
                                }}
                        />
                    <FormHelperText className="Mui-error">{checkvalidacion('year_bautismo',validacion)}</FormHelperText>
                </div>
            </Grid>
        <Grid container>
            {<Grid item xs={12} style={{textAlign:'center'}}>
                    <FormControl>
                        <FormLabel style={{marginTop:'30px',marginBottom:'20px'}}>¿Ha tenido una experiencia real del bautismo en el Espíritu Santo con la señal de hablar en nuevas lenguas según <span className='whitespace-no-wrap'>Hechos 2:4</span>? <span className='c-obl'></span></FormLabel>
                        <RadioGroup
                            value={objetoModificacion.obj.bautismo_es}
                            onChange={(e)=>{
                                    objetoModificacion.set({...objetoModificacion.obj,bautismo_es:e.target.value,fecha_bautismo_es:null})
                            }}>
                                <Box sx={{display:'flex',justifyContent:'center'}}>
                                    <FormControlLabel value="SI" control={<Radio />} label="Si" />
                                    <FormControlLabel value="NO" control={<Radio />} label="No" />
                                </Box>
                        </RadioGroup>
                    </FormControl>
                    <FormHelperText className="Mui-error">{checkvalidacion('bautismo_es',validacion)}</FormHelperText>
            </Grid>}
        </Grid>
</Box>

}






